import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as dealApis from "../../utilities/apis/deal"
import * as productApis from "../../utilities/apis/product"
import Layout from "../../components/Layout"
import { url } from "../../utilities/enumerations/constants"

const Deal = () => {
  const navigate = useNavigate()
  const { user, token } = useSelector(state => state.user)
  const params = new URLSearchParams(window.location.search)
  const thumbnailRef = useRef(null)
  const thumbnailFileRef = useRef(null)
  const thumbnail64Ref = useRef(null)
  const titleRef = useRef(null)
  const slugRef = useRef(null)
  const descriptionRef = useRef(null)
  const costRef = useRef(null)
  const priceRef = useRef(null)
  const discountRef = useRef(null)
  const saleRef = useRef(null)
  const videoRef = useRef(null)
  const whatsappRef = useRef(null)
  const [discount, setDiscount] = useState(0)
  const [products, setProducts] = useState([])
  const [items, setItems] = useState([])
  const [homePage, setHomePage] = useState(false)
  const [selectedOption, setSelectedOption] = useState("")

  const options = products.map((product) => (
    <option key={product.id} value={product.id}>{product.title}</option>
  ))

  const setImage = (type, base64) => {
    switch (type) {
      case "thumbnail":
        thumbnailRef.current.src = base64
        thumbnail64Ref.current.value = base64
        break
    }
  }

  const handleChange = async (e) => {
    try {
      if (e.target.files && e.target.files[0]) {
        if (e.target.files[0].size > 1024000) throw new Error("Image size must be maximum of 1MB")
        if (!["image/jpeg", "image/jpg", "image/png"].includes(e.target.files[0].type)) throw new Error("image must be in format of .jpg, .jpeg or .png")

        const reader = new FileReader()
        const type = e.target.id

        reader.addEventListener("load", function (e) {
          setImage(type, e.target.result)
        })

        reader.readAsDataURL(e.target.files[0])
      }
    } catch (error) {
      alert(error.message)
    }
  }

  const handleClear = (type) => {
    switch (type) {
      case "thumbnail":
        thumbnailRef.current.src = "/upload.png"
        thumbnailFileRef.current.value = ""
        thumbnail64Ref.current.value = ""
        break
    }
  }

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()
      if (items.length < 1) throw new Error("Please add atleast 1 product")

      const formData = new FormData()

      if (e.target.thumbnail.files[0]) formData.append("deal[thumbnail_url]", e.target.thumbnail.files[0])
      else formData.append("deal[thumbnail_url", thumbnail64Ref.current.value)

      formData.append("deal[title]", titleRef.current ? titleRef.current.value : '')
      formData.append("deal[slug]", slugRef.current ? slugRef.current.value : '')
      formData.append("deal[description]", descriptionRef.current ? descriptionRef.current.value : '')
      formData.append("deal[cost]", costRef.current ? costRef.current.value : '')
      formData.append("deal[price]", priceRef.current ? priceRef.current.value : '')
      formData.append("deal[discount]", discountRef.current ? discountRef.current.value : '')
      formData.append("deal[whatsapp_url]", whatsappRef.current ? whatsappRef.current.value : '')
      formData.append("deal[video_url]", videoRef.current ? videoRef.current.value : '')
      formData.append("deal[home_page]", homePage)
      items.forEach((item, index) => {
        formData.append(`deal_products[${index}][quantity]`, item.order_quantity)
        formData.append(`deal_products[${index}][product_id]`, item.id)
      })

      if (!params.has("id")) {
        const response = await dealApis.createDeal(token, formData)
        if (!response.status) throw new Error(response.message)

        titleRef.current.value = ""
        slugRef.current.value = ""
        descriptionRef.current.value = ""
        costRef.current.value = ""
        priceRef.current.value = ""
        discountRef.current.value = ""
        saleRef.current.value = ""
        whatsappRef.current.value = ""
        videoRef.current.value = ""
        handleClear("thumbnail")
        setItems([])
        setDiscount(0)
      } else {
        formData.append("deal[id]", parseInt(params.get("id")))
        const response = await dealApis.updateDeal(token, formData)
        if (!response.status) throw new Error(response.message)
      }

      alert("Deal saved")
    } catch (error) {
      alert(error.message)
    }
  }

  const handleItem = () => {
    const product = products[0]
    const item = {
      id: product.id,
      title: product.title,
      description: product.description,
      cost: product.cost,
      price: product.price,
      quantity: product.quantity,
      category_id: product.category_id,
      user_id: product.user_id,
      order_quantity: 1
    }
    setItems(previous => [...previous, item])
  }

  const handleItemDelete = (index) => {
    setItems(previous => {
      previous.splice(index, 1)
      return [...previous]
    })
  }

  const handleItemChange = (e, index, type) => {
    switch (type) {
      case "id":
        setItems(previous => {
          const product = products.find(product => product.id === parseInt(e.target.value))
          const item = {
            id: product.id,
            title: product.title,
            description: product.description,
            cost: product.cost,
            price: product.price,
            quantity: product.quantity,
            category_id: product.category_id,
            user_id: product.user_id,
            order_quantity: previous[index].order_quantity
          }
          previous[index] = item
          return [...previous]
        })
        break
      case "quantity":
        setItems(previous => {
          previous[index].order_quantity = parseInt(e.target.value)
          return [...previous]
        })
        break
    }
  }

  const getProducts = async () => {
    try {
      const response = await productApis.getProducts(token)
      if (!response.status) throw new Error(response.message)

      setProducts(response.products)
    } catch (error) {
      alert(error.message)
    }
  }

  const getDeal = async () => {
    try {
      const response = await dealApis.getDeal(token, params.get("id"))
      if (!response.status) throw new Error(response.message)

      setHomePage(response.deal.home_page)
      titleRef.current.value = response.deal.title
      slugRef.current.value = response.deal.slug
      descriptionRef.current.value = response.deal.description
      costRef.current.value = response.deal.cost
      priceRef.current.value = response.deal.price
      discountRef.current.value = response.deal.discount
      saleRef.current.value = response.deal.sale
      setSelectedOption(response.deal.primary)
      videoRef.current.value = response.deal.video_url
      whatsappRef.current.value = response.deal.whatsapp_url

      thumbnailRef.current.src = response.deal.thumbnail_url?.replace("public", url)
      thumbnail64Ref.current.value = response.deal.thumbnail_url

      setItems(response.deal.products)
      setDiscount(response.deal.discount)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getProducts()
    if (params.has("id")) getDeal()
  }, [])

  if (costRef && costRef.current)
    costRef.current.value = items.reduce((previous, current) => previous += current.cost * current.order_quantity, 0)
  if (priceRef && priceRef.current) {
    priceRef.current.value = items.reduce((previous, current) => previous += current.price * current.order_quantity, 0)
    saleRef.current.value = items.reduce((previous, current) => previous += current.price * current.order_quantity, 0) - discount
  }

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <form method="POST" onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3 align-items-center">
                  <button type="button" className="btn btn-secondary rounded-4" onClick={() => navigate(-1)}><i className="bi bi-chevron-left"></i></button>
                  <p className="lead text-body-emphasis fw-bold m-0">{params.has("id") ? "Edit" : "Add"} Deal</p>
                </div>
                <button type="submit" className="btn btn-theme rounded-4">Save</button>
              </div>

              <div className="card rounded-4 shadow-none">
                <div className="card-body py-4">
                  <div className="d-flex flex-column gap-3">
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" id="home-page" checked={homePage} onChange={() => setHomePage(!homePage)} />
                      <label className="form-check-label" htmlFor="home-page">Display on Home Page</label>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div>
                          <label htmlFor="title" className="form-label">Title</label>
                          <input ref={titleRef} type="text" className="form-control" id="title" required />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div>
                          <label htmlFor="slug" className="form-label">Slug</label>
                          <input ref={slugRef} type="text" className="form-control" id="slug" required />
                        </div>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="description" className="form-label">Description</label>
                      <textarea ref={descriptionRef} type="text" className="form-control" id="description" rows={8} required></textarea>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-3">
                        <label htmlFor="cost" className="form-label">Cost</label>
                        <input ref={costRef} type="number" className="form-control" id="cost" required disabled />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="price" className="form-label">Price</label>
                        <input ref={priceRef} type="number" className="form-control" id="price" step="0.01" required />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="discount" className="form-label">Discount</label>
                        <input ref={discountRef} type="number" className="form-control" id="discount" step="0.01" required onKeyUp={(e) => setDiscount(parseFloat(e.target.value))} />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="sale" className="form-label">Sale</label>
                        <input ref={saleRef} type="number" className="form-control" id="sale" required disabled />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="whatsapp_url" className="form-label">Whatsapp Url</label>
                        <input ref={whatsappRef} type="text" className="form-control" id="whatsapp" />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="video" className="form-label">Video Url</label>
                        <input ref={videoRef} type="text" className="form-control" id="video" />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Media</label>
                        <div className="card shadow-none position-relative">
                          <a className="reset text-danger" onClick={() => handleClear("thumbnail")}><i className="fas fa-times"></i></a>
                          <div className="card-body p-0">
                            <input ref={thumbnail64Ref} type="hidden" />
                            <input ref={thumbnailFileRef} type="file" id="thumbnail" className="form-control d-none" accept=".jpg, .jpeg, .png" onChange={handleChange} />
                            <img ref={thumbnailRef} src="/upload-white.png" className="rounded" onClick={() => thumbnailFileRef.current.click()} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border rounded-4">
                <table className="table table-sm shadow-none m-0">
                  <thead className="table-light">
                    <tr>
                      <th scope="col" style={{ width: "40%" }} className="align-middle">Product</th>
                      <th scope="col" style={{ width: "24%" }} className="align-middle">Quantity</th>
                      <th scope="col" style={{ width: "12%" }} className="align-middle text-center">Cost</th>
                      <th scope="col" style={{ width: "12%" }} className="align-middle text-center">Price</th>
                      <th scope="col" style={{ width: "12%" }} className="align-middle text-center">
                        <button type="button" className="btn btn-sm btn-light-theme rounded-3" onClick={handleItem}><i className="bi bi-plus-lg"></i></button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => {
                      return (
                        <tr key={index.toString()}>
                          <td className="align-middle"><select className="form-select form-select-sm rounded-3" defaultValue={item.id} onChange={(e) => handleItemChange(e, index, "id")}>{options}</select></td>
                          <td className="align-middle"><input type="number" className="form-control form-control-sm rounded-3" defaultValue={item.order_quantity} onChange={(e) => handleItemChange(e, index, "quantity")} onKeyUp={(e) => handleItemChange(e, index, "quantity")} /></td>
                          <td className="align-middle text-center">{(item.cost * item.order_quantity).toFixed(2)}</td>
                          <td className="align-middle text-center">{(item.price * item.order_quantity).toFixed(2)}</td>
                          <td className="align-middle text-center">
                            <button type="button" className="btn btn-sm btn-light-danger rounded-3" onClick={() => handleItemDelete(index)}><i className="bi bi-x-lg"></i></button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </form>
        </div>
      </main>
    </Layout>
  )
}

export default Deal
